import { HttpClient } from '@angular/common/http'
import { Inject, Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { AppConfig, APP_CONFIG } from 'src/app.config';

@Injectable({
  providedIn: 'root',
})
export class DocumentService {
  public API_URL: string;

  constructor(
    @Inject(APP_CONFIG) appConfig: AppConfig,
    private http: HttpClient
  ) {
    this.API_URL = appConfig.urlApi;
  }

  getDocumentByTypeSupportId(idTypeSupport: number): Observable<any> {
    const url = this.API_URL + '/Documents?supportId=' + idTypeSupport;
    return this.http.get<any>(url);
  }

  deleteDocument(idDocument: number): Observable<any> {
    const url = this.API_URL + '/Documents/' + idDocument;
    return this.http.delete<any>(url);
  }

  uploadDocument(fd: any): Observable<any> {
    const url = this.API_URL + '/Documents/upload';
    return this.http.post<any>(url, fd);
  }
}
